import { useCallback, useEffect, useRef, useState } from 'react'

const cardDetailUiState = new Map()
const removedTabs = new Set(['attachments', 'dependencies', 'comments'])

function rememberCardDetailUi(cardId, updates) {
    if (!cardId) return
    cardDetailUiState.set(cardId, { ...(cardDetailUiState.get(cardId) || {}), ...updates })
    if (cardDetailUiState.size > 100) {
        cardDetailUiState.delete(cardDetailUiState.keys().next().value)
    }
}

export default function useRememberedCardDetailUi(cardId) {
    const detailModalRef = useRef(null)
    const [storedActiveTab, setStoredActiveTab] = useState(
        () => {
            const rememberedTab = cardDetailUiState.get(cardId)?.activeTab
            return removedTabs.has(rememberedTab)
                ? 'checklist'
                : (rememberedTab || 'checklist')
        },
    )
    const activeTab = removedTabs.has(storedActiveTab) ? 'checklist' : storedActiveTab
    const setActiveTab = useCallback((nextTab) => {
        setStoredActiveTab((currentTab) => {
            const resolvedTab = typeof nextTab === 'function' ? nextTab(currentTab) : nextTab
            return removedTabs.has(resolvedTab) ? 'checklist' : resolvedTab
        })
    }, [])

    useEffect(() => {
        rememberCardDetailUi(cardId, { activeTab })
    }, [activeTab, cardId])

    useEffect(() => {
        const savedTop = cardDetailUiState.get(cardId)?.scrollTop
        if (typeof savedTop !== 'number') return undefined
        const frame = requestAnimationFrame(() => {
            if (detailModalRef.current) detailModalRef.current.scrollTop = savedTop
        })
        return () => cancelAnimationFrame(frame)
    }, [cardId])

    const onDetailModalScroll = useCallback((event) => {
        rememberCardDetailUi(cardId, { scrollTop: event.currentTarget.scrollTop })
    }, [cardId])

    return { activeTab, setActiveTab, detailModalRef, onDetailModalScroll }
}
